var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroSectionRedTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 421,
    viewBox: "0 0 101 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.182 82.4078L-189.5 420.389L-337.359 0.526441L100.182 82.4078Z",
    fill: "url(#paint0_linear_304:2137)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304:2137",
    x1: 100.182,
    y1: 82.4078,
    x2: -384.633,
    y2: 253.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSectionRedTriangle);
export default __webpack_public_path__ + "static/media/hero-section-red-triangle.d621bcdf.svg";
export { ForwardRef as ReactComponent };